import React, { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import DeleteIcon from '../../../assets/img/svg/delete-icon.svg'
import AddIcon from '../../../assets/img/svg/add-icon.svg'
import DeletePopup from '../../../component/deletePopup'

const TasksForm = () => {
  const { control, trigger } = useFormContext()
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'propertyTasks'
  })
  const [deleteIndex, setDeleteIndex] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const onDelete = () => {
    remove(deleteIndex)
    openDeleteModal()
    setDeleteIndex(null)
  }

  return (
    <>
      <div className="field_scroll_div">
        <div className="row">
          {fields.map((field, index) => (
            <div className={fields.length - 1 === index ? 'col-md-12' : 'col-md-6'} key={field.id}>
              <div className="input_icon_box">
                <div className="form-group mb-0 w-100">
                  <Controller
                    name={`propertyTasks.${index}.task`}
                    control={control}
                    defaultValue={field.task} // Use default value from field array
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="New Task"
                          value={value}
                          onChange={(val) => {
                            onChange(val)
                            trigger(`propertyTasks.${index}.task`)
                          }}
                        />
                        <small>{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </div>
                {fields.length - 1 === index ? (
                  <div className="icon_box_div add_icon" onClick={() => append({ property_cleaning_task_id: null, task: '' })}>
                    <img src={AddIcon} alt="upload" width={24} />
                  </div>
                ) : (
                  <div
                    className="icon_box_div delete_icon"
                    onClick={() => {
                      setDeleteIndex(index)
                      openDeleteModal()
                    }}
                  >
                    <img src={DeleteIcon} alt="upload" width={17} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={openDeleteModal}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger common-field-btn w-100" onClick={() => onDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default TasksForm
